var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44609 13.3198H21.9441C22.3361 13.3198 22.702 13.1629 22.972 12.8929C23.2508 12.6228 23.3989 12.2483 23.3989 11.8649C23.3814 5.32267 18.0501 0 11.5078 0C7.06496 0 3.03157 2.4392 0.975679 6.37676C0.601088 7.08238 0.871141 7.96223 1.57677 8.33682C2.2911 8.71142 3.16224 8.43265 3.53683 7.72703C5.09618 4.74772 8.15388 2.9009 11.5078 2.9009C15.9593 2.9009 19.6704 6.16768 20.376 10.4276H1.44609C0.644645 10.4276 0 11.0722 0 11.8737C0 12.6751 0.644645 13.3198 1.44609 13.3198Z",
    fill: "#FF8B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.958426 17.1964C2.93592 21.3692 7.10869 24 11.6996 24C11.8651 24 12.0307 24 12.1962 23.9826C16.6303 23.7996 20.5591 21.1949 22.4582 17.179C22.8067 16.4559 22.493 15.5935 21.77 15.2537C21.047 14.9053 20.1845 15.2189 19.8448 15.9419C18.4074 18.9822 15.4368 20.951 12.0829 21.0904C8.46767 21.2385 5.13119 19.2174 3.58056 15.9507C3.23211 15.2276 2.36968 14.9227 1.64663 15.2625C0.92358 15.6109 0.618681 16.4733 0.958426 17.1964Z",
    fill: "#FF8B49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconOrange);
export default __webpack_public_path__ + "static/media/logo-icon-orange.2209b73c1d11c37e9e8fb58f7af77774.svg";
export { ForwardRef as ReactComponent };